import React from 'react';

import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { useConfig } from '../../defaultConfig';
import type { AccountId } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';

type LinkProps = {
    fromAccountId?: AccountId;
};

const EFakturaApprovalListLink: React.FC<LinkProps> = ({ fromAccountId }) => {
    const translated = useTranslation();
    const { approvalListLink } = useConfig();
    if (!approvalListLink) return <></>;
    const query = fromAccountId?.value ? `?id=${fromAccountId?.value}` : '';
    return (
        <div className="show-all-efaktura-link-container">
            <Link
                className="show-all-efaktura-link"
                icon={IconTypes.BUET_PIL_HOEYRE_20}
                href={`${approvalListLink.url}${query}`}
            >
                {translated.eFaktura.seeAll}
            </Link>
        </div>
    );
};

export default EFakturaApprovalListLink;
